export default value => (
  Number.parseInt(value, 10) >= 0 ? Number.parseInt(value, 10) : 0
)
